<template>
    <div class="list_config chartConfig_viewDP">
        <div class="chartDivConfig numViewConfig ">
            <span class="span_til">表头行高</span>
            <el-input v-model="config.titleStyle.height" @change="getRender" type="number" min="10"></el-input>
            <div class="unit">px</div>
        </div>
        <div class="chartDivConfig numViewConfig ">
            <span class="span_til">表体行高</span>
            <el-input v-model="config.bodyStyle.height" @change="getRender" type="number" min="10"></el-input>
            <div class="unit">px</div>
        </div>
        <div class="chartDivConfig numViewConfig ">
            <span class="span_til span_tilMax">分割线宽度</span>
            <el-input v-model="config.bodyStyle.borderWidth" @change="getRender" type="number" min="0"></el-input>
        </div>
        <div class="chartDivConfig colViewConfig ">
            <span class="span_til span_tilMax">分割线颜色</span>
            <el-color-picker v-model="config.bodyStyle.borderColor" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig selViewConfig ">
            <span class="span_til span_tilMax">分割线类型</span>
            <el-select v-model="config.bodyStyle.borderType" placeholder="请选择下划线类型"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in lineList"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig numViewConfig ">
            <span class="span_til">上边距</span>
            <el-input v-model="config.bodyStyle.margin.top" @change="getRender" type="number" min="1"></el-input>
        </div>
        <div class="chartDivConfig numViewConfig ">
            <span class="span_til">下边距</span>
            <el-input v-model="config.bodyStyle.margin.bottom" @change="getRender" type="number" min="1"></el-input>
        </div>
        <div class="chartDivConfig selViewConfig">
            <span class="span_til span_tilMax">轮播或滚轮</span>
            <el-select v-model="config.scrllOrswiper" placeholder="请选择数据滚动方式"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in showStyle"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig numViewConfig " v-if="config.scrllOrswiper=='swiper'" >
            <span class="span_til span_tilMax">轮播速度</span>
            <el-input v-model="config.time" @change="getRender" type="number" step="100" min="0"></el-input>
        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/4/24 8:04 下午
     */

    export default {
        name: 'btn_config_config',
        components: {

        },
        data() {
            return {
                showStyle:[
                    {name:'滚轮',value:'scroll'},
                    {name:'轮播',value:'swiper'}
                ],
                lineList:[
                    {value: 'solid', name: '实线'},
                    {value: 'dashed', name: '虚线'},
                    {value: 'dotted', name: '点线'},
                ],
            }
        },
        props: {
            type: {
                type: String,
                default: ''
            },
        },
        computed: {
            config() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.chart.setting.params;
                } else if (this.type === 'screen') {
                    return this.$store.state.designer.chart.setting.params;
                }
            }
        },
        methods: {
            getRender() {
                if (this.type === 'view') {
                    this.$store.dispatch('viewDPRender');
                } else if (this.type === 'screen') {
                    this.$store.dispatch('screenRender');
                }
            },
        },
        mounted() {
        },
        destroyed() {

        }

    }
</script>

<style lang="less">
    .list_config {
        .chartDivConfig {
            .span_til {
                max-width: 90px !important;
                width: 32% !important;
            }
            /*.span_tilMax {*/
            /*    max-width: 90px !important;*/
            /*    width: 32% !important;*/
            /*}*/
        }
    }
</style>
